module.exports = __webpack_public_path__ + "img/placeholder_avatar.c52d9b30.svg";